{% block sw_category_view_tabs_seo %}
    {% parent %}
    <sw-tabs-item :route="{ name: 'sw.category.detail.upselling', params: { id: $route.params.id } }" title="Upselling">
        {{ $tc('sw-category.upselling.cardTitleUpselling') }}
    </sw-tabs-item>
{% endblock %}